import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('ROOM_MESSAGE').plugin(axiosPlugin);

let fetchRoomMessageAction = redux.fetchActionGet();

let createRoomMessageAction = redux.fetchActionCreate();

let updateRoomMessageAction = redux.fetchActionUpdate();

let deleteRoomMessageAction = redux.fetchActionDelete();

export const TYPES = redux.types;
export const fetchRoomMessage = (roomId, messageId, query = {}) => fetchRoomMessageAction(`/rooms/${roomId}/messages/${messageId}?${queryString.stringify(query)}`);
export const createRoomMessage = (roomId, data = {}) => createRoomMessageAction(`/rooms/${roomId}/messages`, data);
export const createRoomMessageMedia = (roomId, data = {}) => createRoomMessageAction(`/rooms/${roomId}/messages-medias`, data);
export const updateRoomMessage = (roomId, messageId, data = {}) => updateRoomMessageAction(`/rooms/${roomId}/messages/${messageId}`, data);
export const deleteRoomMessage = (roomId, messageId = {}) => deleteRoomMessageAction(`/rooms/${roomId}/messages/${messageId}`);
export const resetRoomMessage = () => redux.actions.reset();

export const roomMessage = redux.reducer();